module.exports = __webpack_public_path__ + "img/luchador-mask.6a5f266e.svg";